import React, { useEffect, useReducer } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { PrimaryText, Timer, EmptyCartModal } from "@components";
import CheckOutForm from "./widgets/checkOutForm";

function CompetitionCheckOut() {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const location = useLocation();
  const playersPriceList = location.state;

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      is_CartEmpty: false,
    }
  );

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (playersPriceList?.length) {
      setState({
        is_CartEmpty: false,
      });
    } else {
      setState({
        is_CartEmpty: true,
      });
    }
  }, [playersPriceList]);

  const back = () => {
    navigate(-1);
    setState({
      is_CartEmpty: false,
    });
  };

  return (
    <>
      <Timer title={"Competition Booking Expired"} />
      <BackBtn onClick={back}>
        <ArrowBackIosNewIcon fontSize="small" sx={{ color: "white" }} />
        <div className="ml-[5px]">
          <PrimaryText className="text-white255 font-bold">
            {t("checkOut.back")}
          </PrimaryText>
        </div>
      </BackBtn>
      <HomeScreenContent>
        <CheckOutForm />
      </HomeScreenContent>
      <EmptyCartModal
        openModal={state.is_CartEmpty}
        closeModal={back}
        errorMessage={"Your booking details is empty please go back"}
      />
    </>
  );
}

const BackBtn = tw.button`
w-auto
h-auto 
flex 
xl1:pl-9  pl-4 
items-center
`;
const HomeScreenContent = tw.div`
w-full
h-auto 
flex
md:pt-[10px]
pt-[20px]
mb-[90px]
`;

export default CompetitionCheckOut;
